/**
 * Phase 15 — shared skeleton rows for list pages.
 *
 * Renders `count` table rows × `cols` ghost cells with a pulse animation,
 * giving the user a visible structure while the first page of data loads.
 * Replaces the duplicated SkeletonRows bodies that were copy-pasted into
 * TeamList / AuditLogList / MonitoringList / RMARecordsList.
 */
export default function SkeletonRows({ count = 5, cols = 5, testId }) {
  const rows = Array.from({ length: count });
  return (
    <>
      {rows.map((_, r) => (
        <tr
          key={r}
          data-testid={testId ? `${testId}-row-${r}` : undefined}
          className="border-t border-slate-100"
        >
          {Array.from({ length: cols }).map((_, c) => (
            <td key={c} className="px-4 py-3">
              <div className="h-3.5 w-full max-w-[160px] animate-pulse rounded bg-slate-200" />
            </td>
          ))}
        </tr>
      ))}
    </>
  );
}
